import { call, put, takeLatest } from 'redux-saga/effects';
import {
    UPDATE_CUSTOMER_REQUEST,
    updateCustomerFailure,
    updateCustomerSuccess
} from "../actions/update-customer-actions";
import {updateCustomer} from "../../../services/customer/customer-service";


function* handleUpdateCustomer(action) {
    try {
        const updatedCustomer = yield call(updateCustomer, action.payload);
        yield put(updateCustomerSuccess(updatedCustomer));
    } catch (error) {
        yield put(updateCustomerFailure(error));
    }
}

export function* watchUpdateCustomer() {
    yield takeLatest(UPDATE_CUSTOMER_REQUEST, handleUpdateCustomer);
}
